module.exports = __webpack_public_path__ + "img/youtube.4dd38621.svg";